class QalaLinkedVariations {
	/**
	 * Constructor.
	 * Fires up our functionality that should always run.
	 */
	constructor() {
		this.targetClass = 'qala-linked-variations__image-box';
		this.hiddenClass = 'hidden-text';
		this.shortDescriptionParent = document.querySelector( '.swatch-short-description' );

		if ( this.shortDescriptionParent ) {
			this.setupEvents();
		}
	}

	/**
	 * Set up event listeners.
	 */
	setupEvents = () => {
		const linkedVariations = document.querySelectorAll( '.qala-linked-variations__group' );
		if ( linkedVariations?.length > 0 ) {
			linkedVariations.forEach( linkedVariationGroup => {
				linkedVariationGroup.addEventListener(
					'mouseover',
					event => {
						this.hoveringLinkedVariations( event.target );
					}
				);
			} );
		}
	};

	/**
	 * Hovering a linked variation group.
	 *
	 * Lets show the short product name if possible.
	 *
	 * @param {HTMLElement} target The target.
	 */
	hoveringLinkedVariations = target => {
		if ( ! target.classList.contains( this.targetClass ) ) {
			return;
		}

		// Get the short description and empty it.
		const variationGroup = target.closest( '.qala-linked-variations__group' );
		const shortDescriptionParent = variationGroup.querySelector( '.swatch-short-description' );
		shortDescriptionParent.innerHTML = '';

		const shortProductName = target?.dataset?.shortProductName;
		if ( shortProductName ) {
			shortDescriptionParent.classList.remove( this.hiddenClass );
			shortDescriptionParent.innerHTML = shortProductName;
		} else {
			shortDescriptionParent.classList.add( this.hiddenClass );
		}
	};
}

// Run our class once dom content is loaded.
document.addEventListener( 'DOMContentLoaded', () => {
	new QalaLinkedVariations();
} );
